@let isInsideSummary = $isInsideSummary();

<form [formGroup]="formGroup">
  <div
    class="x-card x-card_size_m x-white mx-auto"
    [ngClass]="{
      'md:w-1/3 mt-4.5': !isInsideSummary,
      'p-[20px]': isInsideSummary,
    }"
  >
    <header class="flex items-center justify-between mb-4">
      <p class="x-font-body-1-bold">
        {{ 'request_form.obd.obd_status_title' | translate }}
      </p>
      <section>
        @if (formGroup.dirty) {
          <button
            appearance="outline"
            tuiButton
            type="button"
            size="s"
            class="x-white complete-button me-2 rounded-[10px]"
            (click)="cancel()"
          >
            {{ 'request_form.obd.cancel' | translate }}
          </button>
          @if (formGroup.valid) {
            <button
              appearance="primary"
              tuiButton
              type="button"
              size="s"
              class="x-white complete-button rounded-[10px]"
              (click)="updateRequestObdInfo$.next()"
            >
              {{ 'request_form.obd.save' | translate }}
            </button>
          }
        }
      </section>
    </header>

    <tui-textfield
      tuiChevron
      [stringify]="obdStatusStringifyFn"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <input
        placeholder="{{
          'request_form.obd.obd_status_select_placeholder' | translate
        }}"
        tuiSelect
        [formControlName]="FormFields.ObdStatus"
      />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (obdStatus of obdStatusesOptions; track obdStatus.id) {
            <button tuiOption [value]="obdStatus.id">
              {{ 'obd_statuses.' + obdStatus.id | translate }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>
    @if (isObdStatusFieldTouched && obdStatusField.errors?.['required']) {
      <tui-error
        [error]="'request_form.obd.required_error' | translate"
      ></tui-error>
    }
    <div class="x-input-label">
      {{ 'request_form.obd.obd_reading_data_result_label' | translate }}
    </div>
    <tui-textfield
      tuiChevron
      [stringify]="obdReadSuccessStringifyFn"
      [tuiTextfieldCleaner]="true"
      tuiTextfieldSize="m"
    >
      <input
        placeholder="{{
          'request_form.obd.obd_success_read_select_placeholder' | translate
        }}"
        tuiSelect
        [formControlName]="FormFields.ObdReadSuccess"
      />
      <ng-template tuiDropdown>
        <tui-data-list>
          @for (readOption of obdReadSuccessOptions; track readOption.id) {
            <button tuiOption [value]="readOption.value">
              {{ 'obd_success_read.' + readOption.id | translate }}
            </button>
          }
        </tui-data-list>
      </ng-template>
    </tui-textfield>

    <div class="x-input-label">
      {{ 'request_form.obd.obd_comment_label' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input [formControlName]="FormFields.ObdComment" tuiInput />
      </tui-textfield>
      @if (isObdCommentFieldTouched && obdCommentField.errors?.['required']) {
        <tui-error
          [error]="'request_form.obd.required_error' | translate"
        ></tui-error>
      }
    </div>
  </div>
</form>
